var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authentication-bar"},[_c('button',{staticClass:"button",on:{"click":_vm.signIn}},[_vm._v("Add account")]),(_vm.loggedIn)?_c('button',{staticClass:"button",on:{"click":_vm.signOut}},[_vm._v("Sign out")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }